<card-container
	class="card-container"
	#cardContainer
	tabindex="0"
	(contextmenu)="openMenu($event)">
	<div main class="content" [ngClass]="archive.resource_type">
		<!-- #region Thumbnail -->
		<ng-container [ngSwitch]="archive.resource_type">
			<ng-container *ngSwitchCase="RESOURCE_TYPE.SESSION">
				<thumbnail
					[src]="archive.thumbnail_url"
					[fallbackIcon]="'ficon-app-camcorder'"
					[duration]="archive.duration"
					class="media-thumbnail"
				>
				</thumbnail>
			</ng-container>
			<!-- endregion -->

			<div class="folder-icon" *ngSwitchCase="RESOURCE_TYPE.GROUP">
				<i class="ficon-folder-outline"></i>
			</div>

			<div class="activity-icon" *ngSwitchCase="RESOURCE_TYPE.ACTIVITY">
				<i class="ficon-assignment"></i>
			</div>
		</ng-container>
	</div>
	<div info-first-line>
		{{ archive.name }}
		<span *ngIf="!archive.name?.length">&#8212;</span>
	</div>
	<div info-second-line class="owner-line">
		<span *ngIf="!archive.presenters?.length">{{ archive.owner_name }}</span>
		<ellipsis-with-count class="ellipsis" [nameList]="getNameList(archive)"  *ngIf="archive.presenters?.length"></ellipsis-with-count>
	</div>
	<div info-third-line>{{ archive.archived_at | formatDate }}</div>
	<div info-third-line-action-btns>
		<button
			class="menu-btn btn-none"
			[attr.data-cy]="'archive-menu-' + archive.resource_type"
			[attr.aria-label]="'session-list-item_view-options' | translate"
			(click)="openMenu($event)">
			<i class="ficon-app-dots-vertical"></i>
		</button>
		<menu>
			<archive-menu [archived]="archive"></archive-menu>
		</menu>
	</div>
</card-container>
